import { useContext } from "react";
import { API_BASE_URL } from "./constants";
import { Util } from "./Util";

export class Network {

	static async loginUser(body: any) {
		let data, response;
		try {
			const url = Util.buildUrl(API_BASE_URL, "login_user");
			response = await fetch(url, {
				headers: {
					'Content-Type': 'application/json',
					'X-Language': localStorage.getItem("i18nextLng") || 'en',
					'Accept-Language': localStorage.getItem("i18nextLng") || 'en'
				}
				,
				method: 'POST',
				body: JSON.stringify(body)
			});
			data = await response.json();
		} catch (error: any) {
			console.error('Error logging in:', error);
		} finally {
			return { status: response?.status, body: data };
		}
	};

	static netWork = async (url: string, access_token: string, body: string = "", method: string = "POST"): Promise<any> => {
		try {
			const response = await fetch(url, {
				headers: {
					'Authorization': `Bearer ${access_token}`,
					'Content-Type': 'application/json'
				},
				...(Util.compareStrings(method, "POST") && { body: body }),
				method: method
			});

			try {
				const data = await response.json();
				return ({ status: response.status, data });
			} catch (error) {
				return ({ status: response.status });
			}
		} catch (error) {
			console.error("Network operation error:", error);
			return null;
		}
	};
}
